import React, { useState, useEffect } from "react";
import { TextField, Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import MenuItem from "@mui/material/MenuItem";
import API from "../../../utils/api";

const DateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  backgroundColor: "#0c0513",
  color: "#c770f0",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  margin: "0 10px",
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#c770f0",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#c770f0",
    },
    "&:hover fieldset": {
      borderColor: "#c770f0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#c770f0",
    },
  },
}));

const SearchLearning = ({ onDataChange }) => {
  const [searchData, setSearchData] = useState({
    keyword: "",
    category: "all",
  });
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/saveData")
      .then((res) => res.data)
      .then((response) => {
        setCategories([
          {
            value: "all",
            label: "All Data",
          },
          ...response.categories,
        ]);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  const handleDataChange = (field, value) => {
    const newData = { ...searchData, [field]: value };
    setSearchData(newData);

    // Make an Axios request
    API.post("/api/learning/getLearning", newData)
      .then((response) => {
        console.log("Data sent successfully:", response.data);
        onDataChange(response.data); // Pass response data to parent component
      })
      .catch((error) => {
        console.error("There was an error sending the data!", error);
      });
  };

  return (
    <DateContainer>
      <StyledTextField
        style={{ width: "90%" }}
        label="keyword"
        size="small"
        type="text"
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) => {
          handleDataChange("keyword", e.target.value);
        }}
      />
      <Typography variant="h6">-</Typography>

      <StyledTextField
        style={{ width: "40%" }}
        select
        variant="outlined"
        label="Category"
        defaultValue="all"
        size="small"
        name="category"
        onChange={(e) => {
          handleDataChange("category", e.target.value);
        }}
      >
        {categories.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledTextField>
    </DateContainer>
  );
};

export default SearchLearning;
